// extracted by mini-css-extract-plugin
export default {"wrapper":"Hero_wrapper__MKwvA","container":"Hero_container__cZWVX","title":"Hero_title__gMOH3","image-container":"Hero_image-container__n1PQh","image":"Hero_image__ILnK3"};